<template>
  <div id="rulesOfRegulationPage" class="container-fluid">
    <v-main >
      <BackBar/>
      <div class="text-center font19px">
        <i class="fa-regular fa-lock-keyhole fa-lg"></i>
        قوانین مقررات و حریم خصوصی
      </div>
      <div class="row">
        <div class="col-12">
          <div class=" bg-white rounded-lg p-3" v-html="content">
          </div>

        </div>
      </div>

    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
export default {
  name: "RulesOfRegulation",
  metaInfo: {
    title: 'ایوان خانه-  قوانین مقررات و حریم خصوصی',
  },
  components: {BackBar},
  data:()=>({
    content:null,
    showLoaderDialog:false,
  }),
  mounted() {
    this.getData()
  },
  methods:{
    getData() {
      this.showLoaderDialog= true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Publicly/Law", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.content = json.Description
            }
            this.showLoaderDialog= false
          })
          .catch(error => console.log('error', error));

    }
  }

}
</script>
